import getFetchWrapper from '../helpers/getFetchWrapperWithTrackingId';
import { accountSummaryV2CacheKey, useAccountSummaryV2Query } from 'syf-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMainContext } from '../context';
import { autopayEnrollUrl } from '../const/api-endpoints';
import { HttpMethod } from '../const/http-method';
import { onInvalidate } from '../helpers/enrollment';
import { Routes } from '../const';
var useAutopayEnrollment = function () {
    var _a = useMainContext(), accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config, currentRoute = _a.currentRoute;
    var fetchWrapper = getFetchWrapper(config, accountId);
    var queryClient = useQueryClient();
    var accountSummary = useAccountSummaryV2Query({
        config: config,
        keyProps: {
            accountId: accountId,
            accountIdType: accountIdType
        },
        queryOptions: {
            enabled: Boolean(accountId) && Boolean(accountIdType)
        }
    }).data;
    var isPlanSuccessScreen = currentRoute === Routes.PLAN_SUCCESS;
    var shouldUnenrollAutopay = (accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.billing.autopayEnrollment) &&
        !(accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.billing.customerAssistancePlan) &&
        isPlanSuccessScreen;
    var autopay = useMutation({
        mutationKey: [autopayEnrollUrl, { accountId: accountId, accountIdType: accountIdType }],
        mutationFn: function (enrollment) {
            if (enrollment === void 0) { enrollment = false; }
            return fetchWrapper(autopayEnrollUrl, {
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: 'guid',
                    enrollment: enrollment
                }),
                method: HttpMethod.PUT
            });
        },
        onSuccess: function () {
            onInvalidate({
                cacheKey: accountSummaryV2CacheKey({ accountId: accountId, accountIdType: accountIdType }),
                queryClient: queryClient
            });
        },
        onError: function (err) { return onInvalidate({ err: err }); }
    });
    return { autopay: autopay, shouldUnenrollAutopay: shouldUnenrollAutopay };
};
export default useAutopayEnrollment;
//# sourceMappingURL=use-autopay-enrollment.js.map